import { STEP } from '@/types/common';
import { writable } from 'svelte/store';
import appConfig from '@/config';
import { vidDialogOpen } from '@/pages/thumbPreview/viddialog-store';
const defaultStep = appConfig.editorSkip && appConfig.editorSkip > 0 ? STEP.TEST : STEP.CHOOSE_VIDEO;
const { subscribe, update, set } = writable(defaultStep);
// const { subscribe, update } = writable(STEP.TEST);
const actions = {
    update: (index) => {
        vidDialogOpen.set(false);
        update(() => STEP[index]);
    }
};
const step = {
    subscribe,
    ...actions,
    set
};
export default step;
